import React, { useCallback, useMemo } from "react";
import type {
  GenericDonutChartRow,
  PipelineByProjectTypeChartProps,
  PipelineByProjectTypeItem,
} from "../../type";
import { useApp } from "../../../../contexts/AppContext";
import { EMPTY_PIPELINE_BY_PROJECT_TYPE_MESSAGE } from "../../../../utils/consts";
import { GenericDonutChart } from "../ChartTypes/GenericDonutChart";

const toChartRows = (
  series: PipelineByProjectTypeItem[],
): GenericDonutChartRow[] =>
  series.map((item) => ({
    label: item.type,
    value: item.value,
    color: item.color,
  }));

export const PipelineByProjectTypeChart: React.FC<
  PipelineByProjectTypeChartProps
> = ({ title = "Pipeline by Project Type", loading = false, series }) => {
  const { drawerOpen } = useApp();
  const rows = toChartRows(series);
  const percentageByType = useMemo(
    () =>
      Object.fromEntries(series.map((item) => [item.type, item.percentage])),
    [series],
  );

  const tooltipValueFormatter = useCallback(
    (value: number, percent: number, label?: string) => {
      const displayPercent = percentageByType[label ?? ""] ?? percent;
      return `${value.toLocaleString("en-US")} (${displayPercent.toFixed(2)}%)`;
    },
    [percentageByType],
  );

  return (
    <GenericDonutChart
      title={title}
      titleAlign="left"
      data={rows}
      loading={loading}
      height={400}
      minHeight={400}
      emptyMessage={EMPTY_PIPELINE_BY_PROJECT_TYPE_MESSAGE}
      resizeTrigger={drawerOpen}
      tooltipValueFormatter={tooltipValueFormatter}
    />
  );
};
